import { render, staticRenderFns } from "./IbDateTimePicker.vue?vue&type=template&id=53105e94&scoped=true"
import script from "./IbDateTimePicker.vue?vue&type=script&lang=js"
export * from "./IbDateTimePicker.vue?vue&type=script&lang=js"
import style0 from "./IbDateTimePicker.vue?vue&type=style&index=0&id=53105e94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53105e94",
  null
  
)

export default component.exports